/**
 * Centralized SKU identifiers, and the canonical landing pages of the SKUs that
 * are linked from several surfaces, for reuse across the application
 */
export const GENERAL_VISIT_SKU_ID = '400013'
export const FOLLOW_UP_VIDEO_VISIT_SKU_ID = '400015'
/** Follow-up video visit booked from an async clinical review in-person visit order. */
export const ACR_FOLLOW_UP_VIDEO_VISIT_SKU_ID = '300591'
export const PRESCRIPTION_RENEWAL_SKU_ID = '200007'

/**
 * In-person urgent care booking catalog SKU when the active tenant has no
 * `constants.sku.urgentCareSkuId`. Override with NEXT_PUBLIC_URGENT_CARE_SKU_ID
 * (matches Core URGENT_CARE_SKU_ID).
 */
export const URGENT_CARE_SKU_ID = process.env.NEXT_PUBLIC_URGENT_CARE_SKU_ID?.trim() || '400336'

/** Renewal visit SKU for patients who already have GM-prescribed medications to renew. */
export const PRESCRIPTION_RENEWAL_EXISTING_PATIENT_SKU_ID = '400020'

/** Detail page for the general prescription renewal visit. */
export const PRESCRIPTION_RENEWAL_HREF = `/s/prescription-renewal/${PRESCRIPTION_RENEWAL_SKU_ID}`

export function isPrescriptionRenewalStorefrontSkuId(skuId: string | number | undefined | null): boolean {
    return skuId != null && String(skuId) === PRESCRIPTION_RENEWAL_SKU_ID
}

export function isPrescriptionRenewalExistingPatientSkuId(
    skuId: string | number | undefined | null,
    existingPatientSkuId: string = PRESCRIPTION_RENEWAL_EXISTING_PATIENT_SKU_ID,
): boolean {
    return skuId != null && String(skuId) === existingPatientSkuId
}
